import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const MagnetIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-magnet${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M2.66669 3.33333V8.66667C2.66669 10.0812 3.22859 11.4377 4.22878 12.4379C5.22898 13.4381 6.58553 14 8.00002 14C9.41451 14 10.7711 13.4381 11.7713 12.4379C12.7715 11.4377 13.3334 10.0812 13.3334 8.66667V3.33333C13.3334 2.97971 13.1929 2.64057 12.9428 2.39052C12.6928 2.14048 12.3536 2 12 2H11.3334C10.9797 2 10.6406 2.14048 10.3905 2.39052C10.1405 2.64057 10 2.97971 10 3.33333V8.66667C10 9.1971 9.78931 9.70581 9.41423 10.0809C9.03916 10.456 8.53045 10.6667 8.00002 10.6667C7.46959 10.6667 6.96088 10.456 6.58581 10.0809C6.21073 9.70581 6.00002 9.1971 6.00002 8.66667V3.33333C6.00002 2.97971 5.85954 2.64057 5.6095 2.39052C5.35945 2.14048 5.02031 2 4.66669 2H4.00002C3.6464 2 3.30726 2.14048 3.05721 2.39052C2.80716 2.64057 2.66669 2.97971 2.66669 3.33333Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66669 5.33333H6.00002"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.33333H12.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default MagnetIcon;
